import { Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FieldPermissionStyleService {
  
  constructor() {
    // Aplicar estilos globais na inicialização do serviço
    this.applyGlobalStyles();
  }

  public applyGlobalStyles(): void {
    if (document.getElementById('field-permission-styles')) {
      return;
    }
    
    const styleElement = document.createElement('style');
    styleElement.id = 'field-permission-styles';
    
    styleElement.textContent = `
      .field-blocked {
        background-color: #f9f9f9 !important;
        border: 1px solid #ccc !important;
        border-radius: 0.375rem !important; /* 6px - padrão do Tailwind rounded-md */
        box-shadow: inset 0 1px 2px rgba(0,0,0,0.05) !important;
      }
      
      /* Estilos mais fortes para campos somente leitura */
      .field-readonly {
        background-color: #f3f4f6 !important;
        border: 1px solid #d1d5db !important;
        color: #6b7280 !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
        box-shadow: inset 0 1px 2px rgba(0,0,0,0.1) !important;
      }
      
      /* Garantir que os campos de input tenham aparência consistente */
      input.field-readonly, 
      select.field-readonly, 
      textarea.field-readonly,
      input[readonly],
      select[disabled],
      textarea[readonly] {
        background-color: #f3f4f6 !important;
        border-color: #d1d5db !important;
        border-width: 1px !important;
        border-style: solid !important;
        opacity: 0.8 !important;
        color: #6b7280 !important;
      }
      
      /* Estilos específicos para campos em modais de edição */
      .modal input[readonly],
      .modal select[disabled],
      .modal textarea[readonly],
      .modal .campo-nao-editavel,
      .modal [readonly],
      .modal [disabled] {
        background-color: #f3f4f6 !important;
        border: 1px solid #d1d5db !important;
        color: #6b7280 !important;
        opacity: 0.9 !important;
        cursor: not-allowed !important;
        box-shadow: inset 0 1px 2px rgba(0,0,0,0.1) !important;
      }
      
      /* Estilo para campos com ícone de cadeado */
      .lock-icon-container + input,
      .lock-icon-container + select,
      .lock-icon-container + textarea,
      .lock-icon-container + div,
      .lock-icon-container + span {
        background-color: #f3f4f6 !important;
        border: 1px solid #d1d5db !important;
      }
      
      /* Estilos para campos de status com ring quando bloqueados */
      [appfieldpermission] .ring-2,
      [appfieldpermission] .ring-4,
      [appfieldpermission][readonly] ~ div.ring-2,
      [appfieldpermission][readonly] ~ div.ring-4,
      [appfieldpermission][disabled] ~ div.ring-2,
      [appfieldpermission][disabled] ~ div.ring-4,
      [appfieldpermission].field-readonly ~ div.ring-2,
      [appfieldpermission].field-readonly ~ div.ring-4 {
        --tw-ring-color: #9ca3af !important; /* ring-gray-400 */
        --tw-ring-opacity: 1 !important;
        --tw-ring-offset-width: 0px !important;
        --tw-ring-offset-color: #fff !important;
        --tw-ring-offset-shadow: 0 0 #0000 !important;
        --tw-ring-shadow: 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000 !important;
        border-color: #9ca3af !important; /* border-gray-400 */
        background-color: #e5e7eb !important; /* bg-gray-200 */
        opacity: 0.7 !important;
        cursor: not-allowed !important;
      }
      
      /* Estilos específicos para o campo de status dos atendimentos e outros campos com ring/toggle */
      input[formcontrolname="status_attendance"][readonly] ~ div,
      input[formcontrolname="status_attendance"][disabled] ~ div,
      input[formcontrolname="status_attendance"].field-readonly ~ div,
      input[formcontrolname="blocked"][readonly] ~ div,
      input[formcontrolname="blocked"][disabled] ~ div,
      input[formcontrolname="blocked"].field-readonly ~ div,
      input.sr-only[readonly] ~ div,
      input.sr-only[disabled] ~ div,
      input.sr-only.field-readonly ~ div,
      [appfieldpermission].sr-only ~ div.ring-2,
      [appfieldpermission].sr-only ~ div.ring-4,
      [appfieldpermission].sr-only ~ div.border {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
      }
      
      .lock-icon-container {
        transition: all 0.2s ease;
        cursor: not-allowed !important;
      }
      
      .lock-icon-container:hover {
        transform: scale(1.1);
        background-color: #e5e5e5 !important;
      }
      
      .tooltip {
        transition: all 0.2s ease;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
      }
      
      .tooltip:after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 50%;
        margin-left: -5px;
        border-width: 5px 5px 0;
        border-style: solid;
        border-color: #333 transparent transparent;
      }
      
      /* Garantir que o tooltip fique acima de outros elementos */
      .lock-icon-container {
        z-index: 50 !important;
      }
      
      .tooltip {
        z-index: 9999 !important;
      }
      
      .lock-icon-container:hover .tooltip {
        opacity: 1;
        visibility: visible;
      }
    `;
    
    document.head.appendChild(styleElement);
  }
  
  applyReadonlyStyle(element: HTMLElement, renderer: Renderer2, tooltipMessage?: string): void {
    try {
      const isCheckbox = element instanceof HTMLInputElement && element.type === 'checkbox';
      
      if (isCheckbox) {
        renderer.setAttribute(element, 'disabled', 'true');
      } else {
        renderer.setAttribute(element, 'readonly', 'true');
      }
      
      // Aplicar estilos mais evidentes para campos bloqueados
      renderer.addClass(element, 'bg-gray-100');
      renderer.addClass(element, 'cursor-not-allowed');
      
      // Garantir que a borda seja visível
      renderer.setStyle(element, 'border', '1px solid #ccc');
      renderer.setStyle(element, 'border-radius', '0.375rem');
      renderer.setStyle(element, 'box-shadow', 'inset 0 1px 2px rgba(0,0,0,0.05)');
      renderer.removeClass(element, 'rounded-lg');
      renderer.addClass(element, 'rounded-md');
      
      // Adicionar classe personalizada para facilitar estilização adicional via CSS
      renderer.addClass(element, 'field-readonly');
      
      renderer.setAttribute(element, 'tabindex', '-1');
      renderer.setStyle(element, 'pointer-events', 'none');
      renderer.setStyle(element, 'user-select', 'none');
      
      renderer.listen(element, 'click', (event) => {
        event.preventDefault();
        return false;
      });
      
      renderer.listen(element, 'change', (event) => {
        event.preventDefault();
        return false;
      });
      
      if (!tooltipMessage) {
        tooltipMessage = 'Sem permissão para editar';
        if (element.tagName.toLowerCase() === 'button') {
          tooltipMessage = 'Sem permissão para esta ação';
        }
      }
      
      this.addLockIconToField(element, renderer, tooltipMessage);
    } catch (error) {
    }
  }
  
  applyObfuscatedStyle(element: HTMLElement, renderer: Renderer2, tooltipMessage?: string): void {
    try {
      if (element.tagName.toLowerCase() === 'input') {
        const inputField = element as HTMLInputElement;
        
        const originalValue = inputField.value;
        renderer.setAttribute(element, 'data-original-value', originalValue);
        
        const secureValue = '•'.repeat(Math.max(8, originalValue.length));
        inputField.value = secureValue;
        
        renderer.setStyle(element, 'border', '1px solid #ccc');
        renderer.setStyle(element, 'border-radius', '0.375rem');
        renderer.removeClass(element, 'rounded-lg');
        renderer.addClass(element, 'rounded-md');
      } else if (element.tagName.toLowerCase() === 'textarea') {
        const textArea = element as HTMLTextAreaElement;
        const originalValue = textArea.value;
        renderer.setAttribute(element, 'data-original-value', originalValue);
        
        const secureValue = '•'.repeat(Math.max(20, originalValue.length));
        textArea.value = secureValue;
        
        renderer.setStyle(element, 'border', '1px solid #ccc');
        renderer.setStyle(element, 'border-radius', '0.375rem');
        renderer.removeClass(element, 'rounded-lg');
        renderer.addClass(element, 'rounded-md');
      } else if (element.tagName.toLowerCase() === 'select') {
        renderer.setAttribute(element, 'disabled', 'true');
        
        const select = element as HTMLSelectElement;
        const selectedOption = select.options[select.selectedIndex];
        
        if (selectedOption) {
          const originalText = selectedOption.text;
          renderer.setAttribute(element, 'data-original-text', originalText);
          
          const secureText = this.maskValue(originalText);
          selectedOption.text = secureText;
        }
        
        renderer.setStyle(element, 'border', '1px solid #ccc');
        renderer.setStyle(element, 'border-radius', '0.375rem');
        renderer.removeClass(element, 'rounded-lg');
        renderer.addClass(element, 'rounded-md');
      } else {
        const originalText = element.textContent;
        if (originalText) {
          renderer.setAttribute(element, 'data-original-text', originalText);
          element.textContent = this.maskValue(originalText);
        }
        
        renderer.setStyle(element, 'border', '1px solid #ccc');
        renderer.setStyle(element, 'border-radius', '0.375rem');
        renderer.removeClass(element, 'rounded-lg');
        renderer.addClass(element, 'rounded-md');
      }
      
      const preventEvents = ['select', 'selectstart', 'copy', 'cut', 'contextmenu', 'dragstart', 'mouseup', 'mousedown'];
      
      preventEvents.forEach(eventName => {
        renderer.listen(element, eventName, (event) => {
          event.preventDefault();
          event.stopPropagation();
          return false;
        });
      });
      
      if (['input', 'textarea'].includes(element.tagName.toLowerCase())) {
        renderer.listen(element, 'input', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (element.tagName.toLowerCase() === 'input') {
            (element as HTMLInputElement).value = '•'.repeat(8);
          } else {
            (element as HTMLTextAreaElement).value = '•'.repeat(20);
          }
          return false;
        });
      }
      
      // Aplicar estilos visuais para campos não visualizáveis
      renderer.setStyle(element, 'filter', 'blur(4px)');
      renderer.addClass(element, 'obfuscated-field');
      renderer.addClass(element, 'bg-gray-100');
      renderer.addClass(element, 'cursor-not-allowed');
      
      // Impedir seleção e edição - aplicar todas as proteções possíveis
      renderer.setAttribute(element, 'readonly', 'true');
      renderer.setAttribute(element, 'disabled', 'true');
      renderer.setAttribute(element, 'tabindex', '-1');
      renderer.setAttribute(element, 'unselectable', 'on');
      renderer.setAttribute(element, 'onselectstart', 'return false;');
      renderer.setAttribute(element, 'onmousedown', 'return false;');
      renderer.setAttribute(element, 'oncopy', 'return false;');
      renderer.setAttribute(element, 'oncut', 'return false;');
      renderer.setAttribute(element, 'onpaste', 'return false;');
      renderer.setAttribute(element, 'ondragstart', 'return false;');
      renderer.setAttribute(element, 'ondrag', 'return false;');
      
      // Aplicar estilos CSS para impedir seleção
      renderer.setStyle(element, 'pointer-events', 'none');
      renderer.setStyle(element, 'user-select', 'none');
      renderer.setStyle(element, '-webkit-user-select', 'none');
      renderer.setStyle(element, '-moz-user-select', 'none');
      renderer.setStyle(element, '-ms-user-select', 'none');
      
      // Adicionar classe visual para indicar campo bloqueado
      renderer.addClass(element, 'field-blocked');
      renderer.addClass(element, 'bg-gray-50');
      
      const parent = element.parentNode;
      if (parent) {
        const wrapper = renderer.createElement('div');
        renderer.addClass(wrapper, 'obfuscated-wrapper');
        renderer.setStyle(wrapper, 'position', 'relative');
        renderer.setStyle(wrapper, 'display', 'inline-block');
        
        renderer.insertBefore(parent, wrapper, element);
        renderer.appendChild(wrapper, element);
        
        const overlay = renderer.createElement('div');
        renderer.addClass(overlay, 'obfuscated-overlay');
        renderer.setStyle(overlay, 'position', 'absolute');
        renderer.setStyle(overlay, 'top', '0');
        renderer.setStyle(overlay, 'left', '0');
        renderer.setStyle(overlay, 'right', '0');
        renderer.setStyle(overlay, 'bottom', '0');
        renderer.setStyle(overlay, 'z-index', '10');
        renderer.appendChild(wrapper, overlay);
      }
      
      // Determinar o tipo de elemento para personalizar a mensagem
      if (!tooltipMessage) {
        tooltipMessage = 'Sem permissão para visualizar';
        if (element.tagName.toLowerCase() === 'button') {
          tooltipMessage = 'Sem permissão para esta ação';
        }
      }
      
      this.addLockIconToField(element, renderer, tooltipMessage);
      
    } catch (error) {
    }
  }
  
  addLockIconToField(element: HTMLElement, renderer: Renderer2, tooltipText: string = 'Campo bloqueado'): void {
    try {
      let relativeContainer;
      
      let parentElement = renderer.parentNode(element);
      if (parentElement && parentElement.classList && parentElement.classList.contains('relative')) {
        relativeContainer = parentElement;
      } else {
        const computedStyle = window.getComputedStyle(element);
        const originalWidth = computedStyle.width;
        const originalDisplay = computedStyle.display;
        
        const wrapper = renderer.createElement('div');
        renderer.addClass(wrapper, 'relative');
        
        if (originalDisplay && originalDisplay !== 'inline') {
          renderer.setStyle(wrapper, 'display', originalDisplay);
        } else {
          renderer.setStyle(wrapper, 'display', 'inline-block');
        }
        
        if (originalWidth && originalWidth !== 'auto') {
          renderer.setStyle(wrapper, 'width', originalWidth);
        } else {
          if (originalDisplay === 'block') {
            renderer.setStyle(wrapper, 'width', '100%');
          }
        }
        
        const classesToCopy = ['form-control', 'input', 'select', 'form-select'];
        classesToCopy.forEach(className => {
          if (element.classList.contains(className)) {
            renderer.addClass(wrapper, className + '-wrapper');
          }
        });
        
        const parent = renderer.parentNode(element);
        renderer.insertBefore(parent, wrapper, element);
        renderer.removeChild(parent, element);
        renderer.appendChild(wrapper, element);
        
        renderer.setStyle(element, 'width', '100%');
        renderer.setStyle(element, 'box-sizing', 'border-box');
        
        const propertiesToPreserve = ['min-width', 'max-width', 'min-height', 'max-height', 'margin', 'padding', 'height'];
        propertiesToPreserve.forEach(prop => {
          const value = computedStyle.getPropertyValue(prop);
          if (value && value !== '0px') {
            renderer.setStyle(element, prop, value);
          }
        });
        
        if (element.tagName.toLowerCase() === 'input') {
          const inputElement = element as HTMLInputElement;
          if (inputElement.size) {
            renderer.setAttribute(inputElement, 'size', inputElement.size.toString());
          }
        }
        
        renderer.setStyle(wrapper, 'box-sizing', 'border-box');
        renderer.setStyle(wrapper, 'vertical-align', 'middle');
        
        ['border-radius', 'box-shadow'].forEach(prop => {
          const value = computedStyle.getPropertyValue(prop);
          if (value && value !== 'none') {
            renderer.setStyle(wrapper, prop, value);
          }
        });
        
        relativeContainer = wrapper;
      }
      
      const existingOuterIcon = relativeContainer.querySelector('.lock-icon-container');
      if (existingOuterIcon) {
        return;
      }
      
      const outerIconContainer = renderer.createElement('div');
      renderer.addClass(outerIconContainer, 'absolute');
      renderer.setStyle(outerIconContainer, 'top', '-8px');
      renderer.setStyle(outerIconContainer, 'right', '-8px');
      renderer.setStyle(outerIconContainer, 'position', 'absolute');
      renderer.addClass(outerIconContainer, 'bg-gray-200');
      renderer.addClass(outerIconContainer, 'rounded-full');
      renderer.addClass(outerIconContainer, 'p-1');
      renderer.addClass(outerIconContainer, 'shadow-sm');
      renderer.addClass(outerIconContainer, 'lock-icon-container');
      renderer.setStyle(outerIconContainer, 'z-index', '5');
      renderer.setStyle(outerIconContainer, 'transform', 'scale(0.8)');
      renderer.setStyle(outerIconContainer, 'cursor', 'help');
      
      outerIconContainer.innerHTML = `
        <svg class="h-3 w-3 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      `;
      
      renderer.appendChild(relativeContainer, outerIconContainer);
      
      const tooltip = renderer.createElement('span');
      renderer.addClass(tooltip, 'tooltip');
      renderer.setStyle(tooltip, 'position', 'absolute');
      renderer.setStyle(tooltip, 'background-color', '#333');
      renderer.setStyle(tooltip, 'color', 'white');
      renderer.setStyle(tooltip, 'padding', '4px 8px');
      renderer.setStyle(tooltip, 'border-radius', '4px');
      renderer.setStyle(tooltip, 'font-size', '12px');
      // Posicionar o tooltip acima do ícone com posição fixa
      renderer.setStyle(tooltip, 'position', 'fixed');
      renderer.setStyle(tooltip, 'bottom', 'auto');
      
      // Adicionar listener para posicionar o tooltip dinamicamente
      renderer.listen(outerIconContainer, 'mouseenter', () => {
        const rect = outerIconContainer.getBoundingClientRect();
        renderer.setStyle(tooltip, 'left', `${rect.left + rect.width/2}px`);
        renderer.setStyle(tooltip, 'top', `${rect.top - 30}px`);
        renderer.setStyle(tooltip, 'transform', 'translateX(-50%)');
      });
      renderer.setStyle(tooltip, 'z-index', '9999');
      renderer.setStyle(tooltip, 'white-space', 'nowrap');
      renderer.setStyle(tooltip, 'box-shadow', '0 2px 4px rgba(0,0,0,0.2)');
      renderer.setStyle(tooltip, 'pointer-events', 'none');
      tooltip.textContent = tooltipText;
      
      // Gerenciar a visibilidade do tooltip
      renderer.listen(outerIconContainer, 'mouseenter', () => {
        const rect = outerIconContainer.getBoundingClientRect();
        renderer.setStyle(tooltip, 'left', `${rect.left + rect.width/2}px`);
        renderer.setStyle(tooltip, 'top', `${rect.top - 30}px`);
        renderer.setStyle(tooltip, 'transform', 'translateX(-50%)');
        renderer.setStyle(tooltip, 'visibility', 'visible');
        renderer.setStyle(tooltip, 'opacity', '1');
      });
      
      renderer.listen(outerIconContainer, 'mouseleave', () => {
        renderer.setStyle(tooltip, 'visibility', 'hidden');
        renderer.setStyle(tooltip, 'opacity', '0');
      });
      
      // Adicionar o tooltip ao body para evitar problemas de posicionamento
      document.body.appendChild(tooltip);
      
      // Remover o tooltip quando o elemento for destruído
      const cleanup = () => {
        if (document.body.contains(tooltip)) {
          document.body.removeChild(tooltip);
        }
      };
      
      // Adicionar evento para limpar o tooltip quando o elemento for removido
      if (element.parentNode) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.removedNodes) {
              for (let i = 0; i < mutation.removedNodes.length; i++) {
                const node = mutation.removedNodes[i];
                if (node === element || node.contains(element)) {
                  cleanup();
                  observer.disconnect();
                }
              }
            }
          });
        });
        
        observer.observe(element.parentNode, { childList: true, subtree: true });
      }
      
    } catch (error) {
      console.error('Erro ao adicionar ícone de cadeado:', error);
    }
  }
  
  maskValue(value: string): string {
    if (!value) return '';
    
    const visibleChars = 2;
    const length = value.length;
    
    if (length <= visibleChars * 2) {
      return '*'.repeat(length);
    }
    
    const firstPart = value.substring(0, visibleChars);
    const lastPart = value.substring(length - visibleChars);
    const middlePart = '*'.repeat(Math.min(length - (visibleChars * 2), 10));
    
    return `${firstPart}${middlePart}${lastPart}`;
  }
}
